import { Validator } from 'vee-validate';
import { regexVietNameChar, regexUsername, regexPassword, regexNoWhitespace, regexBusinessTaxCode } from '../../utils/regex';

const extendCustomRules = () => {
  Validator.extend('vietNameChar', {
    validate: value => !regexVietNameChar.test(value),
  });
  Validator.extend('noWhitespace', {
    validate: value => regexNoWhitespace.test(value),
  });
  Validator.extend('username', {
    validate: value => regexUsername.test(value),
  });
  Validator.extend('password', {
    validate: value => regexPassword.test(value),
  });
  Validator.extend('taxCode', {
    validate: value => regexBusinessTaxCode.test(value),
  });
};
export default extendCustomRules;



// WEBPACK FOOTER //
// ./src/plugins/vee-validate/custom-rules.js